import { stringifyRoute } from './fn/stringifyRoute';
import { type RouteDefinition } from './define';

export type To =
  | string
  | Partial<{
    /**
     * A URL pathname, beginning with a /.
     */
    pathname: string;
    /**
     * A URL search string, beginning with a ?.
     */
    search: string;
    /**
     * A URL fragment identifier, beginning with a #.
     */
    hash: string;
  }>;

export type NavigateOptions = {
  /** Replace the current entry in the history stack instead of pushing a new one */
  replace?: boolean;
  /** Adds persistent client side routing state to the next location */
  state?: any;
  /** If you are using {@link https://api.reactrouter.com/v7/functions/react_router.ScrollRestoration.html <ScrollRestoration>}, prevent the scroll position from being reset to the top of the window when navigating */
  preventScrollReset?: boolean;
  /** Defines the relative path behavior for the link. "route" will use the route hierarchy so ".." will remove all URL segments of the current route pattern while "path" will use the URL path so ".." will remove one URL segment. */
  relative?: 'route' | 'path';
  /** Wraps the initial state update for this navigation in a {@link https://react.dev/reference/react-dom/flushSync ReactDOM.flushSync} call instead of the default {@link https://react.dev/reference/react/startTransition React.startTransition} */
  flushSync?: boolean;
  /** Enables a {@link https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API View Transition} for this navigation by wrapping the final state update in `document.startViewTransition()`. If you need to apply specific styles for this view transition, you will also need to leverage the {@link https://api.reactrouter.com/v7/functions/react_router.useViewTransitionState.html useViewTransitionState()} hook.  */
  viewTransition?: boolean;
};

export function makeNavigationParams(
  route: RouteDefinition,
  destination?: {
    path?: Record<string, any>;
    hash?: Record<string, any>;
    search?: Record<string, any>;
    options?: NavigateOptions;
  },
) {
  return {
    to: {
      pathname: stringifyRoute(route.path, destination?.path ?? {}),
      hash: ((hash?: string | undefined) => {
        if (!hash) {
          return '';
        }

        return hash.startsWith('#')
          ? hash
          : `#${hash}`;
      })(
        destination?.hash != null
          ? String(destination.hash)
          : undefined,
      ),

      search: (() => {
        // const mapped = {
        //   // If we're not resetting we should keep existing params
        //   // across navigations
        //   ...params.method !== ENavigationMethod.reset
        //     ? url ? Object.fromEntries(url.searchParams) : {}
        //     : {},
        // };
        //
        // for (const [key, value] of Object.entries(params.search ?? {})) {
        //   if (this.parseSearch[key]) {
        //     // If the route we want to navigate to explicitely specifies the key
        //     // in search params
        //     // with an 'undefined' value it means 'delete' the key
        //     if (_.isEmpty(value)) {
        //       delete mapped[key];
        //     } else {
        //       mapped[key] = this.parseSearch[key].serialize(value);
        //     }
        //   }
        // }
        //
        // return !_.isEmpty(mapped)
        //   ? `?${Utils.objToUrlParams(mapped)}`
        //   : '';
        return '';
      })(),
    } satisfies To,
    opts: {} satisfies NavigateOptions,
  };
}

export function makeHref(
  baseURL: string,
  route: RouteDefinition,
  destination?: {
    path?: Record<string, any>;
    hash?: Record<string, any>;
    search?: Record<string, any>;
  },
) {
  const params = makeNavigationParams(route, destination);
  const base = new URL(baseURL);
  base.pathname += params.to.pathname.replace(/^\//, '');
  base.search = params.to.search;
  base.hash = params.to.hash;
  return base.toString();
}
